export async function loadScript(url: string, id?: string) {
  await new Promise<void>((resolve, reject) => {
    let script = document.createElement("script");
    script.type = "text/javascript";
    script.onload = () => {
      resolve();
    };
    script.onerror = () => {
      reject();
      throw new URIError();
    };
    if (id) {
      script.id = id;
    }
    script.src = url;
    document.body.appendChild(script);
  });
}

export function removeScript(id: string) {
  const script = document.getElementById(id);
  if (script) {
    script.remove();
  }
}
